import config from '../config'
import CoreServices from './coreServices'
import { USER_SETTINGS } from '../constants/services'
import axios from 'axios'

class UserSettingsServices extends CoreServices {
  async reportUser(payload) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/reports`, payload, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      return {}
    } catch (error) {
      return { error }
    }
  }

  async GET_NOTIFICATION_SETTINGS() {
    try {
      let response = await fetch(`${this.apiEnpoint}${this.service}${USER_SETTINGS.NOTIFICATION}`, {
        headers: this.headers(this.getToken()),
        method: 'GET'
      })
      let data = await response.json()
      return data
    } catch (error) {
      return { error }
    }
  }

  async UPDATE_NOTIFICATION_SETTINGS(payload) {
    try {
      let response = await fetch(`${this.apiEnpoint}${this.service}${USER_SETTINGS.NOTIFICATION}`, {
        headers: this.headers(this.getToken()),
        body: JSON.stringify(payload),
        method: 'POST'
      })
      let data = await response.json()
      return data
    } catch (error) {
      return { error }
    }
  }

  async GET_CONTENT_SETTINGS() {
    try {
      let response = await fetch(`${this.apiEnpoint}${this.service}${USER_SETTINGS.CONTENT}`, {
        headers: this.headers(this.getToken()),
        method: 'GET'
      })
      let data = await response.json()
      return data
    } catch (error) {
      return { error }
    }
  }

  async UPDATE_CONTENT_SETTINGS(payload) {
    try {
      let response = await fetch(`${this.apiEnpoint}${this.service}${USER_SETTINGS.CONTENT}`, {
        headers: this.headers(this.getToken()),
        body: JSON.stringify(payload),
        method: 'POST'
      })
      let data = await response.json()
      return data
    } catch (error) {
      return { error }
    }
  }
}

export default new UserSettingsServices(USER_SETTINGS.BASE)
